var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoOpenWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 568"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59764",
    d: "M904.935-2662.92h-27.072a1.436 1.436 0 0 1-1.363-1.5 1.436 1.436 0 0 1 1.363-1.5h27.072a1.436 1.436 0 0 1 1.363 1.5 1.436 1.436 0 0 1-1.363 1.5z",
    transform: "translate(-876.5 2665.92)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59765",
    d: "M904.985-2654.078h-27.122a1.436 1.436 0 0 1-1.363-1.5 1.436 1.436 0 0 1 1.363-1.5h27.122a1.436 1.436 0 0 1 1.363 1.5 1.436 1.436 0 0 1-1.363 1.5z",
    transform: "translate(-876.5 2670.578)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59766",
    d: "M905.136-2645.585h-27.272a1.437 1.437 0 0 1-1.364-1.5 1.437 1.437 0 0 1 1.364-1.5h27.273a1.437 1.437 0 0 1 1.364 1.5 1.437 1.437 0 0 1-1.365 1.5z",
    transform: "translate(-876.5 2675.585)",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOpenWhite);
export default __webpack_public_path__ + "static/media/ico_open_white.75eaf507fb36843e77c3cc360829adfb.svg";
export { ForwardRef as ReactComponent };